import { useState, useEffect } from 'react';
import { LogIn, Heart } from 'lucide-react';
import { getRandomAffirmation } from '@/data/affirmations';

const LoginPage = () => {
  const [affirmation, setAffirmation] = useState('');
  
  useEffect(() => {
    setAffirmation(getRandomAffirmation());
    // Change affirmation every 8 seconds
    const interval = setInterval(() => {
      setAffirmation(getRandomAffirmation());
    }, 8000);
    return () => clearInterval(interval);
  }, []);

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/file-room/callback';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-brand-dark flex items-center justify-center">
      <div className="max-w-md w-full mx-4">
        <div className="text-center mb-8">
          <img
            src="/images/site/logo.png"
            alt="ElevateMN"
            className="h-20 mx-auto mb-6"
          />
          <h1 className="text-3xl font-semibold text-white mb-2">The File Room</h1>
          <p className="text-gray-400">ElevateMN Admin Dashboard</p>
        </div>
        
        {/* Affirmation Card */}
        <div className="bg-brand-gold/10 border border-brand-gold/30 p-6 mb-6 text-center">
          <Heart className="w-6 h-6 text-brand-gold mx-auto mb-3" />
          <p className="text-white text-lg italic leading-relaxed">"{affirmation}"</p>
        </div>
        
        <div className="bg-white p-8">
          <h2 className="text-xl font-semibold text-brand-dark mb-4 text-center">
            Team Member Login
          </h2>
          <p className="text-gray-600 text-sm mb-6 text-center">
            Sign in with your Google account. Only authorized team members can access the dashboard.
          </p>
          
          <button
            onClick={handleLogin}
            className="w-full flex items-center justify-center gap-3 bg-brand-dark text-white py-3 px-4 font-medium hover:opacity-90 transition-opacity"
          >
            <LogIn className="w-5 h-5" />
            Sign in with Google
          </button>
          
          <p className="text-xs text-gray-500 mt-6 text-center">
            Need access? Contact your admin to be added as a team member.
          </p>
        </div>
        
        <div className="mt-6 text-center">
          <a href="/" className="text-gray-400 text-sm hover:text-white">
            ← Back to Website
          </a>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
